import { createContext, useContext, useEffect, useState } from 'react'
import { DASHBOARD_TABS } from '../constants/navs'

// Create Authentication Context
const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user')
    return storedUser ? JSON.parse(storedUser) : null
  })

  useEffect(() => {
    const storedUser = localStorage.getItem('user')
    const storedToken = localStorage.getItem('secret')

    if (storedUser && storedToken) setUser(JSON.parse(storedUser))
  }, [])

  const login = (userDataResult) => {
    const { token, ...userData } = userDataResult

    // adds default dashboard permissions
    const dashboardPermissions = DASHBOARD_TABS.map(tab => tab.permission)

    userData.permissions = Array.from(new Set([
      ...(userData.permissions || []),
      ...dashboardPermissions
    ]))

    localStorage.setItem('user', JSON.stringify(userData))
    localStorage.setItem('secret', token)
    setUser(userData)
  }

  const logout = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('secret')
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{
      user,
      setUser,
      login,
      logout
    }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
